import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router'
import { familyQuery } from '@/features/portal/api'

/** The child the family portal is looking at (?student=, else the first linked one). */
export function useChild() {
  const children = useQuery(familyQuery())
  const [params, setParams] = useSearchParams()
  const list = children.data ?? []
  const wanted = Number(params.get('student')) || undefined
  const child = list.find((c) => c.student.id === wanted) ?? list[0]
  const select = (id: number) => {
    const next = new URLSearchParams(params)
    next.set('student', String(id))
    setParams(next, { replace: true })
  }
  return { children, list, child, select }
}
